import LocationIcon from "../../../../assets/svg/LocationIcon";

const About = () => {
  return (
    <div className="flex w-full">
      <div className="w-1/4 mt-4">
        Providing high-caliber recruitment services Since 1989
      </div>
      <div className="flex-1">
        <div className="flex items-center font-medium text-xs text-light-black">
          <LocationIcon className="w-4 h-4" />
          London
        </div>
        <span className="font-medium text-xs text-charcoal">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat.
        </span>
      </div>
    </div>
  );
};

export default About;
